<template>
    <div id="reviews-details">
        <div v-for="(deviceReview, index) in deviceReviews" :key="'review-' + index">
            <div class="row">
                <div class="col-4 col-md-3 col-lg-2 small fw-bold ellipsis">
                    {{ deviceReview.name }}
                </div>
                <div class="col-5 small">
                    <template v-if="deviceReview.verified">
                        <span>{{ verified }}</span>
                        <span
                            class="icon icon-Orange-Trust-Badge text-primary trust-badge"
                            aria-hidden="true"
                        />
                    </template>
                </div>
                <div class="col-12 py-1">
                    <Rating
                        v-if="deviceReview.rating"
                        :average="deviceReview.rating"
                        :rating-results-height="1.25"
                    />
                    <p v-msh-html="deviceReview.description" class="text-mw mb-0" />
                    <p v-if="deviceReview.originallyPublished" v-msh-html="deviceReview.originallyPublished" class="mb-0 small" />
                </div>
            </div>
            <div v-if="index !== deviceReviews.length - 1" class="col-12 px-0">
                <ob1-separateur class="mb-1" />
            </div>
        </div>
    </div>
</template>

<script>


import Rating from "../../../common/components/ob1/Rating.vue";

export default {
    name: "ReviewsDetails",
    components: {Rating},
    props: {
        deviceReviews: {
            type: Array,
            required: true
        },
        verified: {
            type: String,
            required: true
        }
    }
}
</script>

<style scoped lang="scss">
.trust-badge {
    font-size: 0.95rem;
}

.ellipsis {
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
}
</style>
